import React from 'react';
import { Header } from 'layout';
import { withPlaceholder } from 'HOC';
import {
  useExportEtzProfileRevenueByMonth,
  useGetEtzProfileRevenueByMonth,
} from 'hooks/api/etzProfile';
import { ShareIcon_24 } from 'assets/icons';
import Button from 'components/Button';
import EtzProfileNavTabs from '../components/EtzProfileNavTabs';
import EtzProfileBalance from '../components/EtzProfileBalance';
import RenderEtzProfileRevenueTable from '../components/RenderEtzProfileRevenueTable';
import { mapData } from './EtzProfileRevenueTable.columns';

import messages from './EtzProfileRevenueTable.messages';
import styles from './EtzProfileRevenueTable.module.css';

const RenderEtzProfileRevenueTableWithPlaceholders = withPlaceholder(
  RenderEtzProfileRevenueTable,
);

const EtzProfileRevenueTable: React.FC = () => {
  const {
    data: revenueByMonthData,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useGetEtzProfileRevenueByMonth();
  const { mutate: exportEtzProfileRevenueByMonth, isLoading: isProcessing } =
    useExportEtzProfileRevenueByMonth();

  const items = mapData(revenueByMonthData?.items);

  const onExportCsvClick = async (): Promise<void> => {
    exportEtzProfileRevenueByMonth();
  };

  return (
    <>
      <Header title={messages.headerTitle}>
        <Button
          className={styles.buttonExportCsv}
          onClick={onExportCsvClick}
          variant={'outline'}
          isLoading={isProcessing}
          disabled={isProcessing}
        >
          <ShareIcon_24 className={styles.iconExportCsv} />
          {messages.exportCsvButton}
        </Button>
      </Header>
      <EtzProfileNavTabs />
      <EtzProfileBalance />
      <RenderEtzProfileRevenueTableWithPlaceholders
        revenueByMonthData={revenueByMonthData}
        items={items}
        refetch={refetch}
        isRefetching={isRefetching}
        isLoading={isLoading}
        isError={isError}
        isData={!!revenueByMonthData?.context && !!items && items?.length !== 0}
      />
    </>
  );
};

export default EtzProfileRevenueTable;
